// 공통 스타일 (헤더, 로그인 등)
export const commonStyles = {
  // 전체 컨테이너
  container: { 
    height: '100vh',
    backgroundColor: '#f5f5f5', 
    fontFamily: 'Arial, sans-serif',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  },
  
  // 헤더
  header: { 
    backgroundColor: '#2c3e50', 
    color: 'white', 
    padding: '20px 10px', 
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center',
    flexShrink: 0
  },
  title: { 
    margin: 0, 
    fontSize: '24px' 
  },
  headerButtons: { 
    display: 'flex', 
    gap: '10px' 
  },
  
  // 버튼
  navButton: { 
    padding: '8px 16px', 
    backgroundColor: '#34495e', 
    color: 'white', 
    border: 'none', 
    borderRadius: '4px', 
    cursor: 'pointer', 
    fontSize: '14px', 
    transition: 'background-color 0.2s' 
  },
  navButtonActive: { 
    backgroundColor: '#3498db' 
  },
  logoutButton: { 
    padding: '8px 16px', 
    backgroundColor: '#e74c3c', 
    color: 'white', 
    border: 'none', 
    borderRadius: '4px', 
    cursor: 'pointer', 
    fontSize: '14px' 
  },
  
  // 로그인
  loginContainer: { 
    minHeight: '100vh', 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    background: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)', 
    fontFamily: 'Arial, sans-serif' 
  },
  loginCard: { 
    width: '100%', 
    maxWidth: '420px', 
    backgroundColor: 'white', 
    borderRadius: '0', 
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)', 
    overflow: 'hidden' 
  },
  loginHeader: { 
    padding: '60px 40px 50px', 
    textAlign: 'center', 
    background: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)', 
    color: 'white' 
  },
  loginTitle: { 
    fontSize: '56px', 
    fontWeight: 'bold', 
    margin: '0 0 16px 0', 
    color: 'white', 
    letterSpacing: '2px' 
  },
  loginSubtitle: { 
    fontSize: '28px', 
    margin: 0, 
    opacity: 0.95, 
    color: 'white', 
    fontWeight: '500' 
  },
  loginForm: { 
    padding: '40px' 
  },
  inputWrapper: { 
    marginBottom: '24px' 
  },
  loginInput: { 
    width: '100%', 
    padding: '16px', 
    fontSize: '16px', 
    border: '2px solid #ecf0f1', 
    borderRadius: '8px', 
    boxSizing: 'border-box', 
    transition: 'border-color 0.3s' 
  },
  loginButton: { 
    width: '100%', 
    padding: '16px', 
    fontSize: '18px', 
    fontWeight: 'bold', 
    backgroundColor: '#3498db', 
    color: 'white', 
    border: 'none', 
    borderRadius: '8px', 
    cursor: 'pointer', 
    transition: 'background-color 0.3s' 
  },
  loginError: { 
    color: '#e74c3c', 
    fontSize: '14px', 
    marginBottom: '16px', 
    textAlign: 'center', 
    padding: '12px', 
    backgroundColor: '#fadbd8', 
    borderRadius: '6px' 
  }
};
